import { CustomerLoginHeader } from "@/features/session/components/CustomerLoginHeader";
import { withAuth } from "@/hoc/withAuth";
import { background } from "@/theme/colors";
import { Box, Stack } from "@mui/material";
import { FC } from "react";
import { Outlet } from "react-router-dom";

export const SessionLayout: FC = () => {
  return (
    <Box minHeight="100vh" bgcolor={background.primary} py={6} px={3}>
      <Stack maxWidth={1200} mx="auto" gap={10}>
        <CustomerLoginHeader />
        <Outlet />
      </Stack>
    </Box>
  );
};

export const SessionLayoutWithAuth = withAuth(SessionLayout);
